import React from 'react';




export default function TeaserListHeader({children}) {
  return (
    <div className="teaser-list__header"><div className="teaser-list__header__title">{children}</div></div>
  )
}